export const card = {
    wrap: {
        background: '#fff',
        marginBottom: 20,
        padding: 20,
        boxShadow: '0px 1px 2px #cccccc',
        borderRadius: 5,
    },
    head: {
        background: '#fff',
        marginBottom: 0,
        paddingBottom: 10,
        borderTopLeftRadius: 5,
        borderTopRightRadius: 5,
        borderBottom: '1px solid #eee'
    },
    body: {
        background: '#fff',
        marginBottom: 0,
        padding: 20,
    },
    bodyGrey: {
        background: '#fdfdfd',
        marginBottom: 0,
        padding: 20,
    },
    bodyThinGrey: {
        background: '#fdfdfd',
        marginBottom: 0,
        padding: 5,
        paddingBottom: 5,
    },
    submit:{
        background: '#fff',
        marginBottom: 0,
        padding: 20,
    },
    footer: {
        background: '#fff',
        marginBottom: 0,
        padding: 20,
        borderBottomLeftRadius: 5,
        borderBottomRightRadius: 5,
        borderTop: '1px solid #eee'
    },
}

export const section = {
    wrap:{
        paddingBottom: 30,
        borderBottom: '1px solid #ccc'
    },
    header: {
        background: '#fff',
        marginBottom: 0,
        padding: 20,
        borderTopLeftRadius: 5,
        borderTopRightRadius: 5,
        borderBottom: '1px solid #eee'
    },
    body: {
        background: '#fff',
        marginBottom: 0,
        padding: 20,
        borderTopLeftRadius: 5,
        borderTopRightRadius: 5,
        borderBottom: '1px solid #eee'
    },
    title:{
        color: '#666',
        marginBottom:3,
        fontSize: 16
    },
    info:{
        color: '#666',
        marginBottom:10,
        fontSize: 13
    }
}